function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { DeleteButton } from './DeleteButton';
import { DeleteButtonSquare } from './DeleteButtonSquare';

/**
 * Renders the delete button configured for the current market via window.MARKET_CONSTANTS.DELETE_BUTTON_TYPE.
 * 'square' -> DeleteButtonSquare, anything else -> DeleteButton. Props (incl. className) go to whichever is rendered;
 * without a className each keeps its own default.
 */
export function MarketDeleteButton(_ref) {
  let {
    className,
    ...props
  } = _ref;
  if (window.MARKET_CONSTANTS?.DELETE_BUTTON_TYPE === 'square') {
    return /*#__PURE__*/React.createElement(DeleteButtonSquare, _extends({
      className: className
    }, props));
  }
  return /*#__PURE__*/React.createElement(DeleteButton, _extends({}, props, {
    className: ['text-warning', className].filter(Boolean).join(' ')
  }));
}